module.exports = __webpack_public_path__ + "img/services.f68b872c.jpg";